import { useCallback, useEffect, useState } from 'react'

// Open/closed state for a nav filter block, remembered per page.
export function useFilterOpen(storageKey) {
  const [open, setOpen] = useState(() => {
    try {
      return localStorage.getItem(storageKey) === '1'
    } catch {
      return false
    }
  })

  useEffect(() => {
    try {
      localStorage.setItem(storageKey, open ? '1' : '0')
    } catch {
      /* ignore */
    }
  }, [storageKey, open])

  const toggle = useCallback(() => setOpen((current) => !current), [])
  return [open, toggle]
}

// Filter label, Clear all, and the chevron that opens the rest of the fields.
// Sits above a nav list. `last` draws the divider when nothing else is under it.
export function NavFilterLead({ open, active, onToggle, onClear, clearDisabled, last = false }) {
  return (
    <div className={'nav-filter-head nav-filter-lead' + (open ? ' is-open' : '') + (last ? ' is-last' : '')}>
      <div className="nav-filter-lead-label">
        <span className="nav-filter-title">Filter</span>
        <button type="button" className="nav-filter-clear" onClick={onClear} disabled={clearDisabled}>
          Clear all
        </button>
        <button
          type="button"
          className={'nav-filter-toggle' + (open ? ' is-open' : '') + (active ? ' is-active' : '')}
          onClick={onToggle}
          aria-expanded={open}
          aria-label={open ? 'Collapse filters' : 'Expand filters'}
          title={open ? 'Collapse filters' : 'Expand filters'}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            {open ? <polyline points="6 15 12 9 18 15" /> : <polyline points="6 9 12 15 18 9" />}
          </svg>
        </button>
      </div>
    </div>
  )
}
